import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { FuelTypeEnum } from 'src/app/core/constants/FuelType';
import { Product } from 'src/app/models/category.model';
import { MappedProduct, MappedTopping } from '../../new-service/interfaces/Topping';
import { FORM_KEYS } from '../../my-services/components/edit-service-modal/edit-service.service';
import { ProductKey } from 'src/app/core/enums/ProductKey';


export interface FuelTypeOptions {
  Description: string;
  FuelTypeId: number;
  OptionId: number;
  Premium?: boolean;
}

@Component({
  selector: 'app-fuel-charge-topping-step',
  templateUrl: './fuel-charge-topping-step.component.html',
  styleUrls: ['./fuel-charge-topping-step.component.scss']
})
export class FuelChargeToppingStepComponent {

  @Input() MainToppingData!: MappedTopping;
  @Input() ProductsFormArray!: FormArray;
  @Input() FuelTypeId!: FuelTypeEnum;
  @Input() ServiceForm: FormGroup | null | undefined = undefined;
  @Output() ProductDataEmitter = new EventEmitter<any>();

  refillTopping: MappedProduct | null = null;

  FuelTypeOptions: FuelTypeOptions[] = [];

  MonetaryAmounts = [10, 20, 50, 80];
  SelectedMonetaryAmount = 0;

  ToppingProductForm?: FormGroup;

  FORM_KEYS = FORM_KEYS

  ngOnInit() {
    this.ToppingProductForm = this.ProductsFormArray.controls.find(
      (ctrl) => ctrl.value.ProductKey === ProductKey.RefuelingTopping
    ) as FormGroup | undefined;
    this.refillTopping = this.MainToppingData.products[0]
    this.selectMonetaryAmount(this.MonetaryAmounts?.findIndex((amount) => amount === Number(this.ToppingProductForm?.value?.Amount)) + 1);
  }

  selectMonetaryAmount(option: number): void {
    if (option >= 1 && option <= this.MonetaryAmounts.length) {
      this.SelectedMonetaryAmount = option;

      const product = this.MainToppingData?.products?.[0];

      const patchData: any = {
        Amount: this.MonetaryAmounts[this.SelectedMonetaryAmount - 1],
      };

      if (product) {
        patchData.ProductId = product.id;
        patchData.ProductType = product.verticalType;
        patchData.ProductKey = product.productKey;
      }
      if (!this.ToppingProductForm) {
        this.ToppingProductForm = new FormGroup({
          ProductId: new FormControl(patchData.ProductId),
          ProductType: new FormControl(patchData.ProductType),
          ProductKey: new FormControl(patchData.ProductKey),
          Amount: new FormControl(patchData.Amount),
        });

        this.ProductsFormArray.push(this.ToppingProductForm);
      } else {
        if (!this.ToppingProductForm.get('Amount')) {
          this.ToppingProductForm.addControl('Amount', new FormControl());
        }
        this.ToppingProductForm.patchValue(patchData);
      }
    }
  }

  handleFuelTypeSummaryData(): void {
    switch (this.FuelTypeId) {
      case 1:
        this.FuelTypeOptions = [
          { Description: 'fuel95', FuelTypeId: 1, OptionId: 1 },
          { Description: 'fuel98', FuelTypeId: 1, OptionId: 2 },
        ];
        break;
      case 3:
        this.FuelTypeOptions = [
          { Description: 'dieselPremium', FuelTypeId: 3, OptionId: 4 },
          { Description: 'fuel95E10', FuelTypeId: 3, OptionId: 8, Premium: true },
        ];
        break;
      case 5:
        this.FuelTypeOptions = [
          { Description: 'fuel95', FuelTypeId: 1, OptionId: 1 },
          { Description: 'fuel98', FuelTypeId: 1, OptionId: 2 },
          { Description: 'dieselPremium', FuelTypeId: 3, OptionId: 4 },
          { Description: 'fuel95E10', FuelTypeId: 3, OptionId: 8, Premium: true },
        ];
        break;
      default:
        this.FuelTypeOptions = [];
    }
  }

}
